import React, { Component } from 'react';
import RMGrid from 'core/grid';

import Button from 'common/components/Button';
import { myAccountHOC } from 'containers/MyAccount/MyAccount';
import PaypalCheckout from 'common/components/PaypalCheckout';

import { inject, observer } from 'mobx-react';

import debounce from 'lodash/debounce';

import { gridColumns, gridConfig } from 'containers/Register/registerGridOptions';

import { globalConfig, localeStrings as strings } from 'applicationConfig';

import { StringFormatter as stringFormatter } from 'utils/StringFormatter';

const SUBSCRIPTION_CHANGE_HANDLER_NAME = 'Subscriptions';

@inject('userStore')
@inject('settingsStore')
@inject('tradingVenuesStore')
@observer
class Subscriptions extends Component {
  constructor(props) {
    super(props);

    this.subscriptionsChangeHandler = this.subscriptionsChangeHandler.bind(this);
    this.saveSubsriptions = this.saveSubsriptions.bind(this);
    this.refreshSubscriptionState = this.refreshSubscriptionState.bind(this);
    this.onPaymentSuccess = this.onPaymentSuccess.bind(this);
  }

  subscriptionsChangeHandler() {
    this.props.tradingVenuesStore.updateCurrentSubscriptionPrice();
  }

  refreshSubscriptionState() {
    if (globalConfig.NO_PAYPAL_MODE) {
      this.props.tradingVenuesStore.LoadSubscriptionEndDate();
    } else {
      return this.props.tradingVenuesStore.LoadSubscriptions();
    }
  }

  componentWillMount() {
    const store = this.props.tradingVenuesStore;

    store.LoadTadingVenues().then(() => {
      if (globalConfig.NO_PAYPAL_MODE) {
        this.props.tradingVenuesStore.SetReadOnlyDelayedMode();
        this.refreshSubscriptionState();
      } else {
        store.addSubscriptionsChangeHandler(
          SUBSCRIPTION_CHANGE_HANDLER_NAME,
          debounce(this.subscriptionsChangeHandler, globalConfig.DEBOUNCE_MAX_WAIT)
        );
      }
    });
  }

  componentWillUnmount() {
    this.props.tradingVenuesStore.removeSubscriptionsChangeHandler(SUBSCRIPTION_CHANGE_HANDLER_NAME);
  }

  saveSubsriptions(e) {
    e.preventDefault();

    this.props.tradingVenuesStore
      .updateSubsriptions()
      .then(() => {
        // in the background refresh user info to unlock data selection and hide obsolete notification
        this.props.userStore.updateSessionData();
        this.props.settingsStore.showSimpleAlert(strings.myAccount.subscription.updateSucess);
      })
      .then(this.refreshSubscriptionState);

    return false;
  }

  cancelSubscription(orderId, e) {
    e.preventDefault();

    this.props.tradingVenuesStore.cancel(orderId).then(this.refreshSubscriptionState);

    return false;
  }

  onPaymentSuccess() {
    this.refreshSubscriptionState();
  }

  render() {
    const {
      venues,
      subscriptionPrice,
      subscriptionEndDate,
      uncompletedPayments,
      isUpdated
    } = this.props.tradingVenuesStore;

    return (
      <div>
        <p>{strings.myAccount.subscription.intro}</p>
        <p className={null == subscriptionEndDate ? 'invisible' : ''}>
          <b>
            {strings.myAccount.subscription.expirationInfo.replace(
              '$date',
              stringFormatter.formatLongDate(subscriptionEndDate)
            )}
          </b>
        </p>

        <div className="trading-venue-container">
          <RMGrid columns={gridColumns} rows={venues} gridConfig={gridConfig} />
          {uncompletedPayments.length > 0 && <div className="disabling-ovelay" />}
        </div>
        <div>
          <p className={!isUpdated || null === subscriptionPrice ? 'invisible' : ''}>
            <span>{strings.myAccount.subscription.subscriptionPrice}</span>
            <span>{stringFormatter.formatCurrency(subscriptionPrice)} </span>
          </p>
        </div>
        <div className="actions text-align-right">
          <Button className="btn btn-primary" type="submit" onClick={this.saveSubsriptions}>
            <span className="button-caption">{strings.generic.renew}</span>
          </Button>
        </div>

        {uncompletedPayments.length > 0 && (
          <div>
            {uncompletedPayments.filter((payment, i) => i === 0).map((payment, i) => (
              <div key={'payment-' + i}>
                <div className="description">
                  {strings.myAccount.subscription.paymentIntro.replace(
                    '$price',
                    stringFormatter.formatCurrency(payment.orderPrice)
                  )}
                </div>

                <div className="paygroup">
                  <span className="paypalButton">
                    <PaypalCheckout
                      createParams={{
                        orderId: payment.orderId,
                        paymentCheckUrl: globalConfig.PAYPAL_CHECK_PAYMENT_URL
                      }}
                      onExecutePaymentSuccess={this.onPaymentSuccess}
                    />
                  </span>

                  <span className="cancelButton">
                    <Button
                      className="btn btn-primary"
                      type="submit"
                      onClick={this.cancelSubscription.bind(this, payment.orderId)}
                    >
                      <span className="button-caption">{strings.generic.cancel}</span>
                    </Button>
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
        <p>
          <span>{strings.myAccount.emailInfo} </span>
          <a className="mailto" href={'mailto:' + strings.myAccount.infoEmailAddress}>
            {strings.myAccount.infoEmailAddress}
          </a>
        </p>
      </div>
    );
  }
}

export default myAccountHOC(Subscriptions);



// WEBPACK FOOTER //
// ./src/containers/MyAccount/Subscriptions/Subscriptions.jsx